import { createTheme } from '../../../utils';

import * as Edit from './Edit/Edit.css';

export const defaultTheme = {
	Edit
};

export default defaultTheme;

export const { useTheme } = createTheme<typeof defaultTheme>(defaultTheme);
